var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('delete-dialog',{attrs:{"title":'activiteiten.dialoog.titel',"content":'activiteiten.dialoog.content',"delete-object":_vm.deleteObject,"value":_vm.value},on:{"on-deleted":_vm.verwijder,"annuleer":_vm.annuleer}})
}
var staticRenderFns = []

export { render, staticRenderFns }